import { useEffect, useRef, useState } from "react";
import YouTube from 'react-youtube';



function Short({ short, shortContainerRef }) {
  const [player, setPlayer] = useState(null);
  const [isPlaying, setIsPlaying] = useState(true);
  const [isMuted, setIsMuted] = useState(false);
  const [isLiked, setIsLiked] = useState(short.reaction.isLiked);

  const handleVideoReady = (event) => {
    setPlayer(event.target);
    handleVideo();
  };

  const handlePlayPause = () => {
    if (player) {
      if (isPlaying) {
        player.pauseVideo();
        setIsPlaying(false);
      } else {
        player.playVideo();
        setIsPlaying(true);
      }
    }
  };

  const handleMuteUnmute = () => {
    if (player) {
      if (isMuted) {
        player.unMute();
        setIsMuted(false);
      } else {
        player.mute();
        setIsMuted(true);
      }
    }
  };

  const handleVideo = () => {
    if (player && player.getIframe()) {
      const playerTop = player.getIframe().getBoundingClientRect().top;
      if (playerTop > 0 && playerTop <= 150) {
        try {
          player.playVideo();
          setIsPlaying(true);
        } catch (error) {
          setIsPlaying(false);
          player.pauseVideo();
        }
      } else {
        player.seekTo(0);
        player.pauseVideo();
      }
    }
  };
  const isActiveVideo = () => {
    if (player) {
      const playerTop = player.getIframe().getBoundingClientRect().top;
      return playerTop > 0 && playerTop <= 150;
    }
    return false;
  };
	
	useEffect(() => {
		const handleScroll = () => {
		  handleVideo();
		};

		shortContainerRef.current.addEventListener("scroll", handleScroll);

		const handleBlur = () => {
		  if (isActiveVideo()) {
			player.pauseVideo();
			setIsPlaying(false);
		  }
		};

		const handleFocus = () => {
		  if (isActiveVideo()) {
			player.playVideo();
			setIsPlaying(true);
		  }
		};

		window.addEventListener("blur", handleBlur);
		window.addEventListener("focus", handleFocus);

		return () => {
		  //shortContainerRef.current.removeEventListener("scroll", handleScroll);
		  window.removeEventListener("blur", handleBlur);
		  window.removeEventListener("focus", handleFocus);
		};
	  }, [shortContainerRef, handleVideo, isActiveVideo, player]);



  return (
    <div className="reel">
      <div className="reel-video">
        <div className="video">
            <YouTube
              videoId={short.videoId} // Assuming you have a videoId property in your short object
              onReady={handleVideoReady}
			  className="video"
			  loading="lazy"
              opts={{
                playerVars: {
                  autoplay: 1,
                  controls: 0,
                  loop: 1,
                  mute: isMuted ? 1 : 0,
                  playsinline: 1,
				  showinfo: 0,
				  rel: 0,
				  origin: "https://shorts.m-arabi.com",
				  enablejsapi: 0,
                },
              }}
            />
		  
          <div className="controls">
            <span onClick={handlePlayPause}>
              <ion-icon name={`${isPlaying ? "pause" : "play"}-outline`}></ion-icon>
            </span>
            <span onClick={handleMuteUnmute}>
              <ion-icon name={`volume-${isMuted ? "mute" : "medium"}-outline`}></ion-icon>
            </span>
          </div>
          <div className={`play-pause ${isPlaying ? "" : "show-play-pause"}`}>
            <ion-icon name="play-outline"></ion-icon>
          </div>
          <div className="foot">
            <div className="title">{short.title}</div>
            <div className="user-info">
              <div>
                <img src={short.profileUrl} alt="" />
                <span>{short.username}</span>
              </div>
              {!short.isFollowed && <button>Follow</button>}
            </div>
          </div>
        </div>
        <div className="reaction">
          <div
            className=""
            onClick={() => {
              setIsLiked(!isLiked);
            }}
          >
            {isLiked ? (
              <span className="like">
                <ion-icon name="heart"></ion-icon>
              </span>
            ) : (
              <span className="unlike">
                <ion-icon name="heart-outline"></ion-icon>
              </span>
            )}

            <span className="value">{short.reaction.likes}</span>
          </div>
          <div>
            <ion-icon name="chatbubble-outline"></ion-icon>
            <span className="value">{short.reaction.comments}</span>
          </div>
          <div>
            <ion-icon name="arrow-redo-outline"></ion-icon>
          </div>
          <div>
            <ion-icon name="ellipsis-vertical-outline"></ion-icon>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Short;
